import LanguageGame from '../../pages/language/game/index'
import ChannelIndex from '../../pages/language/channel/index'
import LanguageGameStore from '../../pages/language/game/store'
import LanguageGameLink from '../../pages/language/game/link'
import LanguageBanner from '../../pages/language/banner'

const LanguageGameRoute = [
  {
    path: '/languageGame',
    name: 'languageGame',
    component: LanguageGame
  },
  {
    path: '/languageGameStore',
    name: 'languageGameStore',
    component: LanguageGameStore
  },
  {
    path: '/languageChannel',
    name: 'languageChannel',
    component: ChannelIndex
  },
  {
    path: '/languageGameLink',
    name: 'languageGameLink',
    component: LanguageGameLink
  },
  {
    path: '/languageBanner',
    name: 'languageBanner',
    component: LanguageBanner
  }
]

export default LanguageGameRoute



// WEBPACK FOOTER //
// ./src/router/language/index.js